export const DETAIL_TABLE_WIDER_DATES_HINT = 'Go back and pick wider dates to see more.';
